import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { isEmpty } from 'dpl/shared/utils/object';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';
import useForm from 'dpl/shared/form/hooks/useForm';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import { BUYER_BASE_PATH } from 'dpl/shared/constants/urls';

import { resetPasswordMutationDefinition } from './queryDefinitions';

export default function UserAuthResetPasswordFormV2({ match }) {
  const { resetToken } = match.params;
  const unverifiedLogin = useSelector(
    ({ queryParams }) => queryParams.unverified_login === 'true'
  );

  const { mutateAsync: resetPassword } = useResourceMutation(
    resetPasswordMutationDefinition()
  );

  const {
    formState,
    handleFieldChange,
    handleSubmission,
    formErrors,
    isSubmitting,
    didSubmissionFail
  } = useForm({
    defaultFormState: {
      password: '',
      password_confirmation: ''
    },
    validationSchema: {
      password: CONSTRAINT_TYPES.PASSWORD,
      password_confirmation: {
        presence: true,
        equality: {
          attribute: 'password',
          message: "Passwords don't match"
        }
      }
    },
    onSubmit: formData =>
      resetPassword({
        body: {
          unverified_login: unverifiedLogin,
          user: {
            ...formData,
            reset_password_token: resetToken
          }
        }
      }).then(() => {
        window.location = BUYER_BASE_PATH;
      })
  });

  function handleSubmit(e) {
    e.preventDefault();
    handleSubmission();
  }

  return (
    <form className="UserAuthResetPasswordForm" onSubmit={handleSubmit}>
      <h1 className="mb4 font-32">Reset your password</h1>

      <div className="mb6">
        <label htmlFor="password">
          <p className="dark-gray mb2 f2">Password</p>
          <ErrorWrapper
            errors={formErrors.password}
            isShown={didSubmissionFail}
          >
            <input
              name="password"
              type="password"
              className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
              value={formState.password || ''}
              onChange={handleFieldChange}
              placeholder="6+ characters"
            />
          </ErrorWrapper>
        </label>
      </div>

      <div className="mb10">
        <label htmlFor="password_confirmation">
          <p className="dark-gray mb2 f2">Password (confirm)</p>
          <ErrorWrapper
            errors={formErrors.password_confirmation}
            isShown={didSubmissionFail}
          >
            <input
              type="password"
              name="password_confirmation"
              className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
              value={formState.password_confirmation || ''}
              onChange={handleFieldChange}
            />
          </ErrorWrapper>
        </label>
      </div>

      <button
        className={`w-100 button button--primary ph14 pv4 center ${
          isSubmitting ? 'button--loading' : ''
        }`}
        disabled={isSubmitting || !isEmpty(formErrors)}
        type="submit"
      >
        Submit
      </button>
    </form>
  );
}

UserAuthResetPasswordFormV2.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      resetToken: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
